module.exports = __webpack_public_path__ + "static/media/Sec-1_2677_Banner_EN_Mobile.c6b41b5a.jpg";